// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApprovalStatus } from './approval-status';
import {
    ApprovalStatusFromJSON,
    ApprovalStatusFromJSONTyped,
    ApprovalStatusToJSON,
    ApprovalStatusToJSONTyped,
} from './approval-status';

/**
 * 
 * @export
 * @interface WorkflowApproval
 */
export interface WorkflowApproval {
    /**
     * 
     * @type {string}
     * @memberof WorkflowApproval
     */
    approval_comment?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowApproval
     */
    approval_id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowApproval
     */
    approved_at: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowApproval
     */
    approver_id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowApproval
     */
    approver_name: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowApproval
     */
    approver_role: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowApproval
     */
    dta_id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowApproval
     */
    rejection_reason?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowApproval
     */
    stage: string;
    /**
     * 
     * @type {ApprovalStatus}
     * @memberof WorkflowApproval
     */
    status: ApprovalStatus;
}



/**
 * Check if a given object implements the WorkflowApproval interface.
 */
export function instanceOfWorkflowApproval(value: object): value is WorkflowApproval {
    if (!('approval_id' in value) || value['approval_id'] === undefined) return false;
    if (!('approved_at' in value) || value['approved_at'] === undefined) return false;
    if (!('approver_id' in value) || value['approver_id'] === undefined) return false;
    if (!('approver_name' in value) || value['approver_name'] === undefined) return false;
    if (!('approver_role' in value) || value['approver_role'] === undefined) return false;
    if (!('dta_id' in value) || value['dta_id'] === undefined) return false;
    if (!('stage' in value) || value['stage'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function WorkflowApprovalFromJSON(json: any): WorkflowApproval {
    return WorkflowApprovalFromJSONTyped(json, false);
}

export function WorkflowApprovalFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowApproval {
    if (json == null) {
        return json;
    }
    return {
        
        'approval_comment': json['approval_comment'] == null ? undefined : json['approval_comment'],
        'approval_id': json['approval_id'],
        'approved_at': json['approved_at'],
        'approver_id': json['approver_id'],
        'approver_name': json['approver_name'],
        'approver_role': json['approver_role'],
        'dta_id': json['dta_id'],
        'rejection_reason': json['rejection_reason'] == null ? undefined : json['rejection_reason'],
        'stage': json['stage'],
        'status': ApprovalStatusFromJSON(json['status']),
    };
}

export function WorkflowApprovalToJSON(json: any): WorkflowApproval {
    return WorkflowApprovalToJSONTyped(json, false);
}

export function WorkflowApprovalToJSONTyped(value?: WorkflowApproval | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'approval_comment': value['approval_comment'],
        'approval_id': value['approval_id'],
        'approved_at': value['approved_at'],
        'approver_id': value['approver_id'],
        'approver_name': value['approver_name'],
        'approver_role': value['approver_role'],
        'dta_id': value['dta_id'],
        'rejection_reason': value['rejection_reason'],
        'stage': value['stage'],
        'status': ApprovalStatusToJSON(value['status']),
    };
}
